import { CompetencyWithEvaluation } from "../types/GrowthWheel"

export enum CompetencyStatus {
    COMPLETE = 'complete',
    PENDING = 'pending',
}

export const getCompletedCompetencies = (competencies: CompetencyWithEvaluation[]) => {
    return competencies.filter((competency) => competency.evaluation?.selfLevel !== null).length
}

export const getTotalCompetencies = (competencies: CompetencyWithEvaluation[]) => {
    return competencies.length
}

export const getPageTransitionClass = (isTransitioning: boolean, transitionDirection: 'left' | 'right' | null) => {
    return isTransitioning && transitionDirection
        ? `gw-competency-area-page--enter-${transitionDirection}`
        : ''
}

export const getListTransitionClass = (isTransitioning: boolean, transitionDirection: 'left' | 'right' | null) => {
    return isTransitioning && transitionDirection
        ? `gw-competency-area-competencies-list--enter-${transitionDirection}`
        : ''
}


export enum ConfirmModalType {
  FOCUS = 'focus',
  UNFOCUS = 'unfocus',
  ALERT = 'alert',
}
